const date = new Date();
export const leadInteractionFields = vueInstance => [
  {
    name: 'contactMethod',
    title: vueInstance.$t('contactMethod'),
    type: 'select',
    possibleOptions: [],
    useDictionary: true,
    defaultValue: null
  },
  {
    name: 'isImportant',
    title: vueInstance.$t('isImportant'),
    type: 'select',
    possibleOptions: [
      { name: vueInstance.$t('yes'), slug: true },
      { name: vueInstance.$t('no'), slug: false }
    ],
    defaultValue: false
  },
  {
    name: 'status',
    title: vueInstance.$t('prospectStatusSelect'),
    type: 'select',
    possibleOptions: [],
    useDictionary: true,
    useGlobalTrad: true,
    defaultValue: null,
    onChange: vueInstance.statusFieldOnChange
  },
  {
    name: 'subStatus',
    title: vueInstance.$t('prospectSubStatusSelect'),
    type: 'select',
    possibleOptions: [],
    useDictionary: true,
    useGlobalTrad: true,
    defaultValue: null,
    updatable: true
  },
  {
    name: 'nextScheduleDate',
    title: vueInstance.$t('nextScheduleDate'),
    type: 'datepicker',
    defaultValue: new Date(date.getFullYear(), date.getMonth(), date.getDate() + 5)
  },
  {
    name: 'remindersActive',
    title: vueInstance.$t('remindersActive'),
    type: 'select',
    possibleOptions: [
      { name: vueInstance.$t('yes'), slug: true },
      { name: vueInstance.$t('no'), slug: false }
    ],
    defaultValue: null
  }
];
